import * as React from "react";
import getRideFilterInput from "../../../../shared/helpers/getRideFilterInput/getRideFilterInput";
import { Ride } from "../../../../shared/types/schema";
import usePagination, { paginationVar } from "../../../../state/usePagination/usePagination";
import useRideFilter, { rideFilterVar } from "../../../../state/useRideFilter/useRideFilter";
import useRideSort, { rideSortVar } from "../../../../state/useRideSort/useRideSort";
import useSelectedRides, { selectedRidesVar } from "../../../../state/useSelectedRides/useSelectedRides";
import { useFilterRidesForRideTableHeaderQuery } from "../../api/operations.generated";
import TableHeaderRow from "../../ui/tableHeaderRow/TableHeaderRow";

const RideTableHeader: React.FC = () => {
  const [rideFilter] = useRideFilter(rideFilterVar);
  const [rideSort] = useRideSort(rideSortVar);
  const [selectedRides, , setMultiple, , removeAll] = useSelectedRides(selectedRidesVar);
  const [pagination] = usePagination(paginationVar);

  const { data, loading } = useFilterRidesForRideTableHeaderQuery({
    variables: {
      pageRequest: pagination,
      rideFilter: getRideFilterInput(rideFilter, false, false),
      sort: rideSort,
    },
    fetchPolicy: process.env.NODE_ENV === "test" ? "network-only" : "cache-only",
  });

  let filteredRides: Array<Ride["id"]> = [];
  let numberOfFilteredRides = 0;
  let numberOfSelectedRides = 0;

  if (data?.filterRides) {
    filteredRides = data.filterRides.items.map((ride) => ride.id);
    numberOfFilteredRides = filteredRides.length;
    numberOfSelectedRides = selectedRides.length;
  }

  const getCheckboxCheckedState = (numOfFilteredRides: number, numOfSelectedRides: number) => {
    if (numOfSelectedRides > 0 && numOfSelectedRides === numOfFilteredRides) {
      return true;
    }

    return false;
  };

  const isCheckboxChecked = getCheckboxCheckedState(numberOfFilteredRides, numberOfSelectedRides);

  const handleSelectCheckbox = () => {
    if (isCheckboxChecked) {
      return removeAll();
    }

    return setMultiple(filteredRides);
  };

  return (
    <TableHeaderRow
      isCheckboxDisabled={loading || numberOfFilteredRides === 0}
      isCheckboxChecked={isCheckboxChecked}
      isCheckboxIndeterminate={!isCheckboxChecked && numberOfSelectedRides > 0}
      onSelectCheckbox={handleSelectCheckbox}
    />
  );
};

export default RideTableHeader;
